import React from 'react';
import { Phone, Mail, MapPin, Instagram } from 'lucide-react';
import { useLegal, LEGAL_MODALS } from '../context/LegalContext';
import { scrollToSection } from '../utils/scrollToSection';
import '../styles/footer.css';

const Footer = () => {
  const { openLegalModal, showBanner } = useLegal();

  const services = [
    'Reformas Integrales',
    'Construcción en General',
    'Portones Automáticos',
    'Tratamientos de Agua',
    'Climatización',
    'Mantenimiento Integral',
  ];

  const zones = ['Alicante', 'Benidorm', 'Torrevieja', 'Altea', 'Calpe', 'Denia'];

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-grid">
          <div className="footer-column">
            <div className="footer-logo">
              <div className="logo-text">
                IDEAS <span className="logo-accent">COSTA BLANCA</span>
              </div>
              <div className="logo-subtitle">Reformas · Construcción · Mantenimiento</div>
            </div>
            <p className="footer-description">
              Empresa integral especializada en construcción, reformas y mantenimiento en toda la Costa Blanca.
              Más de 20 años de experiencia y 500 proyectos completados.
            </p>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">SERVICIOS</h4>
            <ul className="footer-links">
              {services.map((service, index) => (
                <li key={index}>
                  <button onClick={() => scrollToSection('servicios')} className="footer-link">
                    {service}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">ZONAS</h4>
            <ul className="footer-links">
              {zones.map((zone, index) => (
                <li key={index}>
                  <span className="footer-link">{zone}</span>
                </li>
              ))}
            </ul>
          </div>

          <div className="footer-column">
            <h4 className="footer-title">CONTACTO</h4>
            <ul className="footer-contact">
              <li>
                <Phone size={16} />
                <a href="tel:+34604150871">+34 604 150 871</a>
              </li>
              <li>
                <Mail size={16} />
                <a href="mailto:info@ideascostablanca.com">info@ideascostablanca.com</a>
              </li>
              <li>
                <MapPin size={16} />
                <span>Costa Blanca, Alicante</span>
              </li>
              <li>
                <Instagram size={16} />
                <a
                  href="https://instagram.com/ideascostablanca"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-instagram-link"
                >
                  @ideascostablanca
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="footer-bottom">
          <div className="footer-copyright">
            © {new Date().getFullYear()} Ideas Costa Blanca. Todos los derechos reservados.
          </div>
          <div className="footer-legal">
            <button
              type="button"
              className="footer-legal-link"
              onClick={() => openLegalModal(LEGAL_MODALS.PRIVACIDAD)}
              data-testid="footer-link-privacidad"
            >
              Política de Privacidad
            </button>
            <span className="footer-divider">·</span>
            <button
              type="button"
              className="footer-legal-link"
              onClick={() => openLegalModal(LEGAL_MODALS.AVISO)}
              data-testid="footer-link-aviso"
            >
              Aviso Legal
            </button>
            <span className="footer-divider">·</span>
            <button
              type="button"
              className="footer-legal-link"
              onClick={() => openLegalModal(LEGAL_MODALS.COOKIES)}
              data-testid="footer-link-cookies"
            >
              Política de Cookies
            </button>
            <span className="footer-divider">·</span>
            <button
              type="button"
              className="footer-legal-link"
              onClick={showBanner}
              data-testid="footer-configurar-cookies"
            >
              Configurar cookies
            </button>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;